// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { Helmet } from 'react-helmet';
import { useAuth } from './hooks/useAuth';

import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/ContactUs';
import History from './pages/History';
import ProductsServices from './pages/ProductsServices';
import Dashboard from './pages/Dashboard';
import NotFound from './pages/NotFound';

const App = () => {
  const { user } = useAuth();

  return (
    <Router>
      <Helmet>
        <title>Afework International</title>
        <meta name="description" content="Afework International provides high-quality medical equipment and services worldwide." />
      </Helmet>
      <div className="App">
        <Navbar />
        <div className="content-wrapper">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/history" element={<History />} />
            <Route path="/products-services" element={<ProductsServices />} />
            <Route path="/dashboard" element={user ? <Dashboard /> : <Navigate to="/login" />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
